import React from "react";
import { FaMicrophone } from "react-icons/fa";
import PageHeader from "../../../core/common/header/PageHeader";
import AudioReviewPage from "../../admin/audio/AudioReviewPage";

const MentorAudioReviewPage: React.FC = () => (
  <div className="min-h-screen bg-gray-100">
    <PageHeader
      icon={<FaMicrophone />}
      title="Speaking Practice"
      breadcrumb={[
        { label: "Home", to: "/" },
        { label: "Dashboard", to: "/mentor/dashboard" },
        { label: "Speaking Practice" },
      ]}
    />
    <main className="max-w-7xl mx-auto px-4 sm:px-6 py-6">
      <AudioReviewPage
        apiBase={`${process.env.REACT_APP_API_BASE_URL}/api/mentor`}
        batchesUrl={`${process.env.REACT_APP_API_BASE_URL}/api/mentor/my-batches`}
      />
    </main>
  </div>
);

export default MentorAudioReviewPage;
